export default __webpack_public_path__ + "static/quote-c94f51db51c80bf9ced0d25093289fe5.png";